import { useBalanceStore } from '@/domains/balance/store'
import { useUserQuery } from '@/domains/user/queries'

export const useBalance = () => {
  const balance = useBalanceStore((state) => state.balance)
  const { data: user } = useUserQuery()

  // Fallback to user query until client side balance is hydrated
  return balance ?? user?.balance
}
